import { render, staticRenderFns } from "./user_certificate.vue?vue&type=template&id=2e15180f&scoped=true"
import script from "./user_certificate.vue?vue&type=script&lang=js"
export * from "./user_certificate.vue?vue&type=script&lang=js"
import style0 from "./user_certificate.vue?vue&type=style&index=0&id=2e15180f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e15180f",
  null
  
)

export default component.exports